import { useState } from "react";
import { Modal } from "../primitives/Modal";
import { Button } from "../primitives/Button";

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  onConfirm,
  onCancel
}: ConfirmDialogProps) {
  const [isConfirming, setIsConfirming] = useState(false);

  const handleConfirm = async () => {
    setIsConfirming(true);
    try {
      await onConfirm();
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <Modal open={open} onClose={onCancel} title={title}>
      {description && <p className="text-sm text-ink-muted mb-6">{description}</p>}
      <div className="flex justify-end gap-3">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isConfirming}>
          {cancelLabel}
        </Button>
        <Button
          type="button"
          onClick={handleConfirm}
          disabled={isConfirming}
          className={danger ? "bg-red-600 text-white hover:bg-red-700" : undefined}
        >
          {isConfirming ? "Please wait…" : confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
